/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-01T17:31:37.223
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialAdjustmentApplyDetail,
	listFinancialAdjustmentApplyDetailInit,
	listFinancialAdjustmentApplyDetailByAuthorizations,
	deleteFinancialAdjustmentApplyDetail
} from '@api/financial/FinancialAdjustmentApplyDetail';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialAdjustmentApplyDetail({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialAdjustmentApplyDetail(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialAdjustmentApplyDetailByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialAdjustmentApplyDetailByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialAdjustmentApplyDetailInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialAdjustmentApplyDetailInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialAdjustmentApplyDetail({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialAdjustmentApplyDetail({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
